(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("SellerCampaignsController", SellerCampaignsController);

    /** @ngInject */
    function SellerCampaignsController(
        Principal,
        SellerCampaignService,
        $state,
        $translate,
        paginationConstants,
        $localStorage
    ) {
        var vm = this;

        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.currentPage = 1;
        vm.numPerPage = 20;
        vm.maxSize = 5;

        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var sellerCampaignsLocalStorageKey = 'campaignSellerlistFilter_' + userId + '_' + storeId;
        var sellerCampaignsOrderLocalStorageKey = 'campaignSellerlistOrder_' + userId + '_' + storeId;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null,
        };

        vm.account = undefined;
        vm.userProfile = undefined;

        vm.loadingSellerCampaings = false;
        vm.sellerCampaignsList = [];

        vm.totalSellerCampaigns = vm.sellerCampaignsList.length;

        vm.isMyAgendas = 'MY_ACTIVITIES';

        vm.statusMap = {
            PENDING: 'PENDING',
            DOING: 'DOING',
            DONE: 'DONE'
        };

        vm.deadlineMap = {
            NORMAL: 'NORMAL',
            MEDIAN: 'MEDIAN',
            URGENT: 'URGENT',
            INDETERMINATE: 'INDETERMINATE'
        };

        vm.filter = !angular.isUndefined($localStorage[sellerCampaignsLocalStorageKey]) ? $localStorage[sellerCampaignsLocalStorageKey] : {
            status: [
                {
                    id: vm.statusMap.PENDING,
                    label: $translate.instant('seller-campaigns.list.badges.pending')
                },
                {
                    id: vm.statusMap.DOING,
                    label: $translate.instant('seller-campaigns.list.badges.in-progress')
                },
            ],
            search: "",
            orderBy: 'expirationDate',
            orderDirection: "asc",
            deadline: ""
        };

        vm.status = [
            {
                id: vm.statusMap.PENDING,
                label: $translate.instant('seller-campaigns.list.badges.pending')
            },
            {
                id: vm.statusMap.DOING,
                label: $translate.instant('seller-campaigns.list.badges.in-progress')
            },
            {
                id: vm.statusMap.DONE,
                label: $translate.instant('seller-campaigns.list.badges.done')
            }
        ];

        vm.deadline = [
            {
                value: vm.deadlineMap.NORMAL,
                label: $translate.instant('seller-campaigns.list.deadlines.normal')
            },
            {
                value: vm.deadlineMap.MEDIAN,
                label: $translate.instant('seller-campaigns.list.deadlines.median')
            },
            {
                value: vm.deadlineMap.URGENT,
                label: $translate.instant('seller-campaigns.list.deadlines.urgent')
            },
            ,
            {
                value: vm.deadlineMap.INDETERMINATE,
                label: $translate.instant('seller-campaigns.list.deadlines.indeterminate')
            }
        ];

        vm.selectedTab = vm.isMyAgendas;

        vm.selectedSort = !angular.isUndefined($localStorage[sellerCampaignsOrderLocalStorageKey]) ? $localStorage[sellerCampaignsOrderLocalStorageKey] : null;

        vm.isMobile = detectar_mobile();
        var requestSeq = 0;
        var lastRequestSignature = null;

        vm.filterCampaigns = function () {
            vm.changePage(1);
        };

        vm.getSortOptions = [
            {id: 0, label: $translate.instant('seller-campaigns.filter.order-by'), value: "name", direction: 'asc'},
            {id: 1, label: "A-Z", value: "name", direction: 'asc'},
            {id: 2, label: "Z-A", value: "name", direction: 'desc'},
            {id: 3, label: $translate.instant('seller-campaigns.filter.deadline'), value: "expirationDate", direction: 'asc'},
        ];

        vm.changePage = function (page) {
            if (page) {
                vm.currentPage = page;
            }

            getPageOptionsInfo();
            getSellerCampaigns(vm.paginationOptions, vm.filter);
        };

        function getPageOptionsInfo () {
            var begin = (vm.currentPage - 1) * vm.numPerPage,
                end = begin + vm.numPerPage;

            var totalOfTab = vm.totalSellerCampaigns;

            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;
            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, totalOfTab);
        }

        init();

        function init() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                }
            });
            getSellerCampaigns(vm.paginationOptions, vm.filter);
        }

        function getSellerCampaigns(pagination, filter) {
            var params = angular.copy(filter);
            var formatedStatusFilter = params.status.map(function (item) {
                return item.id;
            });
            var formattedDeadline = params.deadline ? params.deadline.value : "";
            params.page = pagination.page;
            params.size = pagination.size;
            params.status = formatedStatusFilter;
            params.deadline = formattedDeadline;

            var signature = JSON.stringify({
                page: params.page,
                size: params.size,
                status: params.status,
                search: params.search,
                orderBy: params.orderBy,
                orderDirection: params.orderDirection,
                deadline: params.deadline
            });
            if (signature === lastRequestSignature && vm.loadingSellerCampaings) {
                return;
            }
            lastRequestSignature = signature;
            var seq = ++requestSeq;
            vm.loadingSellerCampaings = true;

            SellerCampaignService.findBySellerId(params).then(
                function (response) {
                    if (seq !== requestSeq) {
                        return;
                    }
                    vm.sellerCampaignsList = response.data.items;
                    vm.totalSellerCampaigns = response.data.totalMyAgendas;
                    vm.totalStarted = response.data.totalStarted;
                    getPageOptionsInfo();
                    vm.loadingSellerCampaings = false;
                }
            ).catch(function (err) {
                if (seq !== requestSeq) {
                    return;
                }
                vm.loadingSellerCampaings = false;
            });
        }

        vm.viewActivities = function (id) {
            $state.go("seller-campaigns.seller-activities", {
                campaignId: id,
            });
        };

        vm.changeTab = function (tab) {
            vm.selectedTab = tab;
            getSellerCampaigns(vm.paginationOptions, vm.filter);
        };

        function clearPaginationInfo() {
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        vm.loadFilter = function () {
            clearPaginationInfo();
            getSellerCampaigns(vm.paginationOptions, vm.filter);
            $localStorage[sellerCampaignsLocalStorageKey] = vm.filter;
        };

        vm.onChangeItemsPerPage = function (newValue) {
            if (newValue == null || newValue === vm.numPerPage) {
                return;
            }
            vm.numPerPage = newValue;
            vm.changePage();
        };

        vm.onChangeDeadline = function(value) {
            vm.filter.deadline = value ? vm.deadline.find(function (item) {
                if (!item) return false;
                return item.value === value;
            }) : null;
            vm.loadFilter();
        };

        vm.onSelectedSortOption = function (newValue) {
            if (newValue.id !== 0) {
                var sameOrder = vm.filter.orderBy === newValue.value && vm.filter.orderDirection === newValue.direction;
                vm.filter.orderBy = newValue.value;
                vm.filter.orderDirection = newValue.direction;
                $localStorage[sellerCampaignsOrderLocalStorageKey] = newValue;
                if (sameOrder) {
                    return;
                }
                vm.loadFilter();
            }
        };
        vm.incrementStarted = function () {
            if (vm.totalStarted !== undefined && vm.totalStarted !== null) {
                vm.totalStarted += 1;
            }
        };
    }
})();
